import { Archive, ArchiveRestore, Trash2 } from "lucide-react";

const COPY = {
  archive: {
    title: (n) => `Archive ${n} request${n === 1 ? "" : "s"}?`,
    body: "They move to Archived and leave the active board. Linked assignments are archived with them and nothing is deleted — restore them any time from the Archived view, where permanent deletion is a separate step. This action is logged.",
    confirm: "Archive",
    icon: Archive,
    danger: false,
  },
  restore: {
    title: (n) => `Restore ${n} request${n === 1 ? "" : "s"}?`,
    body: "They return to the active board with their archived assignments. This action is logged.",
    confirm: "Restore",
    icon: ArchiveRestore,
    danger: false,
  },
  purge: {
    title: (n) => `Permanently delete ${n} request${n === 1 ? "" : "s"}?`,
    body: "This cannot be undone. The requests and their archived assignments are removed for good. The deletion is logged with your name and the time.",
    confirm: "Delete permanently",
    icon: Trash2,
    danger: true,
  },
};

export const BoardConfirm = ({ action, ids, isWorking, reasons = [], reason = "", onReasonChange, onCancel, onConfirm }) => {
  const copy = COPY[action];
  const Icon = copy.icon;
  return (
    <section className="board-confirm" data-testid={`board-confirm-${action}`}>
      <div className={`board-confirm-icon ${copy.danger ? "is-danger" : ""}`}><Icon size={18} /></div>
      <h2>{copy.title(ids.length)}</h2>
      <p>{copy.body}</p>
      {action === "archive" && reasons.length > 0 && (
        <label className="board-confirm-reason">
          Archive reason
          <select data-testid="board-archive-reason-select" value={reason} onChange={(event) => onReasonChange(event.target.value)}>
            {reasons.map((item) => <option key={item}>{item}</option>)}
          </select>
          <small>“Cancelled by client” removes the position from the fill rate.</small>
        </label>
      )}
      <ul className="board-confirm-ids" data-testid="board-confirm-ids">
        {ids.slice(0, 6).map((id) => <li key={id}>{id}</li>)}
        {ids.length > 6 && <li>+{ids.length - 6} more</li>}
      </ul>
      <div className="board-confirm-actions">
        <button className="button button-secondary" data-testid="board-confirm-cancel" type="button" onClick={onCancel}>Cancel</button>
        <button
          className={`button ${copy.danger ? "projection-confirm-delete-button" : "button-primary"}`}
          data-testid="board-confirm-submit"
          disabled={isWorking}
          type="button"
          onClick={onConfirm}
        >
          <Icon size={14} /> {isWorking ? "Working…" : copy.confirm}
        </button>
      </div>
    </section>
  );
};
